export default __webpack_public_path__ + "static/media/fluchsammler_cover.760041b9.webp";